var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStressedTenseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 70,
    viewBox: "0 0 69 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 68.0045C53.0015 68.0045 68 53.005 68 34.5022C68 15.9995 53.0015 1 34.5 1C15.9985 1 1 15.9995 1 34.5022C1 53.005 15.9985 68.0045 34.5 68.0045Z",
    fill: "white",
    stroke: "#231F20",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5817 54.9736C42.9237 50.6661 39.131 47.3398 34.5008 47.3398C29.8706 47.3398 26.0899 50.6542 25.4199 54.9616C29.3322 53.3104 36.0562 51.6832 43.5817 54.9616V54.9736Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1634 21.5684C27.2491 22.7529 24.1624 24.0332 20.1902 23.6742C19.0297 25.2775 18.1803 27.3236 17.917 29.6687C17.2829 35.2325 20.0347 40.1262 24.0786 40.5928C28.1225 41.0595 31.9152 36.9196 32.5493 31.3438C33.0279 27.18 31.6041 23.411 29.1754 21.5684H29.1634Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7624 33.6886C30.081 30.9049 28.7001 28.4606 26.6782 28.2292C24.6562 27.9977 22.7588 30.0667 22.4402 32.8504C22.1216 35.634 23.5024 38.0783 25.5244 38.3097C27.5463 38.5412 29.4438 36.4722 29.7624 33.6886Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.143 13.8984C32.143 13.8984 30.4202 20.9937 22.9545 21.9509C22.9545 21.9509 16.6971 22.7287 13.6582 16.2316C13.6582 16.2316 22.44 22.6808 32.143 13.9104V13.8984Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8691 13.8984C36.8691 13.8984 38.5921 20.9937 46.0578 21.9509C46.0578 21.9509 52.3151 22.7287 55.354 16.2316C55.354 16.2316 46.5602 22.6808 36.8691 13.8984Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6734 21.5684C42.5877 22.7529 45.6745 24.0332 49.6466 23.6742C50.8071 25.2775 51.6566 27.3236 51.9198 29.6687C52.5539 35.2325 49.8021 40.1262 45.7582 40.5928C41.7143 41.0595 37.9216 36.9196 37.2875 31.3438C36.8089 27.18 38.2327 23.411 40.6614 21.5684H40.6734Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.272 38.3529C46.2939 38.1214 47.6748 35.6772 47.3562 32.8935C47.0375 30.1098 45.1401 28.0408 43.1181 28.2723C41.0962 28.5038 39.7153 30.948 40.0339 33.7317C40.3525 36.5154 42.25 38.5843 44.272 38.3529Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2404 2.36523C49.2404 2.36523 42.3011 13.8876 49.2404 13.8876C56.1797 13.8876 49.2404 2.36523 49.2404 2.36523Z",
    fill: "#00ADEB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStressedTenseIcon);
export default __webpack_public_path__ + "static/media/stressed-tense-icon.b2cc214b800c0e43c81736758265e3b5.svg";
export { ForwardRef as ReactComponent };